import { render } from "./intro-message.vue?vue&type=template&id=7eb556a8&lang=pug"
import script from "./intro-message.vue?vue&type=script&lang=js"
export * from "./intro-message.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__